import React from 'react';

export const Header = (props) => {
    return (
        <header className="header">
            <section className="hero">
                <img className="hero-portroit" src={`${process.env.PUBLIC_URL}/assets/hero.png`} alt="Portada del Sitio Web de Selgi Obregon" />
                <img className="hero-profile" src={`${process.env.PUBLIC_URL}/assets/perfil.png`} alt="Selgi Obregon" />
            </section>
            <section className="site-wrapper">
                <h1 className="header__title">Selgi Obregon</h1>
                <h2 className="header__subtitle">Comestologo</h2>
                <p className="header__caption">
                    Nueve años de experiencia graduada de estilista y colorimetria en 2011
                </p>
                <p className="header__caption">
                    9 años de experiencia, Graduada de Cosmetología Miami fl
                </p>
                <p className="header__caption">
                    En el 2018, realizando cursos de actualizaciones usando los mejores productos
                </p>
            </section>
        </header>
    );
};